import * as React from "react";
import { Util } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { alertLabels } from "../../configuration/alert-labels/configuration/alert-labels/index.js";
import { useErrorMessageContext } from "../../context/ErrorMessageContext/context/ErrorMessageContext/context.js";
import { GET_RETURN_FOR_LOGIN } from "../../operations/queries/operations/queries/get-return-for-login.js";
import { getStatusBasedErrorLabel } from "../../utils/utils/get-status-based-error-label.js";
const useLogin = ({ onCompleted, onError } = {}) => {
  const [{ addError, clearErrors }] = useErrorMessageContext();
  const handleOnCompleted = React.useCallback(
    (result) => {
      clearErrors();
      if (result.getReturn?.failures && result.getReturn?.failures.length > 0) {
        const labelMap = Util.mapFailuresToAlertLabels(
          result.getReturn?.failures,
          alertLabels,
          "returns.errors.returnGeneralFailure.title"
        );
        labelMap.forEach((label) => addError(label));
      }
      if (result.getReturn?.return && result.getReturn?.return?.status !== "RETURNABLE") {
        const errorLabel = getStatusBasedErrorLabel(result.getReturn.return.status);
        addError(errorLabel);
      }
      onCompleted?.(result);
    },
    [addError, clearErrors, onCompleted]
  );
  const [query, { called, data, error, loading }] = useLazyQuery(GET_RETURN_FOR_LOGIN, {
    onCompleted: handleOnCompleted,
    onError(error2) {
      console.error(error2);
      onError?.();
    },
    fetchPolicy: "no-cache"
  });
  const trigger = React.useCallback(
    (input) => {
      query({ variables: { input } });
    },
    [query]
  );
  return React.useMemo(
    () => [
      trigger,
      {
        called,
        data,
        error,
        loading
      }
    ],
    [trigger, called, data, error, loading]
  );
};
export {
  useLogin
};
//# sourceMappingURL=use-login.js.map
